import type { Program } from 'models';
import { useState } from 'react';
import { routes } from 'routes/routes';
import { Avatar, Button, Card, Flex, Link } from 'ui';

import { useProgramUsersQuery } from '../queries';
import { CreateContentModal } from './create-content-modal';

type P = {
  program: Program;
  programId: string;
};

const ProgramTopPanel = ({ program, programId }: P) => {
  const { data: usersPreview } = useProgramUsersQuery({ filter: { programId }, pagination: { pageSize: 3 } });

  const [isCreateContent, setIsCreateContent] = useState(false);

  const usersPreviewLeftCount = usersPreview ? usersPreview.joinedCount - usersPreview.users.length : 0;

  return (
    <Card>
      <Flex align="center" justify="space-between">
        <Flex align="center">
          <Button
            onClick={() => {
              setIsCreateContent(true);
            }}
            type="primary"
          >
            Create content
          </Button>

          <CreateContentModal
            isOpened={isCreateContent}
            onCancel={() => {
              setIsCreateContent(false);
            }}
            programContentObject={program}
          />
        </Flex>

        {usersPreview && usersPreview.users.length > 0 ? (
          <Link to={routes.program.members(programId)}>
            <Flex align="center">
              {usersPreview.users.map((user) => (
                <Avatar key={user.id} size={34} src={user.profilePhoto}>
                  {user.name}
                </Avatar>
              ))}
              {usersPreviewLeftCount > 0 ? <span>+{usersPreviewLeftCount}</span> : null}
            </Flex>
          </Link>
        ) : null}
      </Flex>
    </Card>
  );
};

export default ProgramTopPanel;
